module.exports = __webpack_public_path__ + "924096742512dcc28e94c22b11e63ed6.pdf";